import { render, staticRenderFns } from "./PassengersHowItWorksLine03.vue?vue&type=template&id=3867056e&"
import script from "./PassengersHowItWorksLine03.vue?vue&type=script&lang=js&"
export * from "./PassengersHowItWorksLine03.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports